import { Cols } from '@hospitality-bot/admin/shared';

export enum TableValue {
  room = 'ROOM',
  roomType = 'ROOM_TYPE',
}

export const cols: Record<TableValue, Cols[]> = {
  [TableValue.room]: [
    {
      field: 'type',
      header: 'Room No / Type',
      isSortDisabled: true,
      sortType: 'string',
      searchField: ['type', 'roomNo'],
      width: '23%',
    },
    {
      field: 'date',
      header: 'Updated at',
      sortType: 'date',
      isSearchDisabled: true,
    },
    {
      field: 'foStatus',
      header: 'FO Status',
      sortType: 'string',
      isSearchDisabled: true,
    },
    // {
    //   field: 'price',
    //   header: 'Price',
    //   sortType: 'number',
    //   width: '23%',
    // },
    {
      field: 'status',
      header: 'Action / Status',
      sortType: 'string',
      isSearchDisabled: true,
      width: '16%',
    },
  ],
  [TableValue.roomType]: [
    {
      field: 'name',
      header: 'Type',
      sortType: 'string',
      width: '27%',
    },
    {
      field: 'area',
      header: 'Area (in Sq. Ft.)',
      sortType: 'number',
      width: '10%',
    },
    {
      field: 'roomCount',
      header: 'Room Count',
      sortType: 'number',
      width: '10%',
    },
    {
      field: 'amenities',
      header: 'Services',
      isSortDisabled: true,
      width: '31%',
    },
    {
      field: 'occupancy',
      header: 'Occupancy',
      sortType: 'number',
      width: '12%',
    },
    {
      field: 'status',
      header: 'Action',
      sortType: 'number',
      width: '16%',
      isSearchDisabled: true,
    },
  ],
};

export const roomDetailsCols: Cols[] = [
  {
    field: 'roomNo',
    header: 'Room Number',
    sortType: 'number',
    width: '20%',
  },
  {
    field: 'floorNo',
    header: 'Floor',
    sortType: 'number',
    width: '20%',
  },
  {
    field: 'status',
    header: 'Room Status',
    sortType: 'string',
    width: '20%',
  },
  {
    field: 'foStatus',
    header: 'FO Status',
    sortType: 'string',
    width: '20%',
  },
  {
    field: 'action',
    header: 'Action',
    isSortDisabled: true,
    isSearchDisabled: true,
    width: '20%',
  },
];

export const title: Record<TableValue, string> = {
  [TableValue.room]: 'Room',
  [TableValue.roomType]: 'Room Type',
};
